import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import SubmodClassForm from '../components/forms/SubmodClassForm';
import '../styles/EmployeeMaster.css';
import SubmodClassTable from '../components/SubmodClassTable';

const SubmodClassModel = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const showModal = location.pathname === '/submodClass/add';

  const handleAddClick = () => {
    navigate('/submodClass/add');
  };

  const handleCloseModal = () => {
    navigate('/submodClass');
  };

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>SubmodClass Master</h2>
        <button className="add-employee-btn" onClick={handleAddClick}>
          Add SubmodClass
        </button>
      </div>

      <SubmodClassTable />

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New SubmodClass</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SubmodClassForm />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary">
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SubmodClassModel;
